// import { v4 as uuid } from 'uuid'

const getImageQrCodeBase64 = (url, width, errorCorrectionLevel = 'H', dark = '#000000', light = '#ffffff') => {
  return new Promise((resolve) => {
    var QRCode = require('qrcode')
    var opts = {
      version: 'low',
      errorCorrectionLevel,
      type: 'image/png',
      quality: 0.3,
      margin: 0,
      width,
      color: {
        dark,
        light
      }
    }
    QRCode.toDataURL(url, opts, function (err, qrCodeBase64) {
      if (err) throw err
      resolve(qrCodeBase64)
    })
  })
}

export default getImageQrCodeBase64
